/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import VitalSourceAccessCodeSetup from './VitalSourceAccessCodeSetup';
import {assignCompCodeVS, getCompCodeVS} from '../../../_thunks/collection.thunk';

function mapStateToProps(state, props) {
    return {
        isCompCodeGenerateEnabled: !state.opsAdminCompCode.code,
        collectionId: state.activeCollection.collectionId,
        opsAdminCompCode: state.opsAdminCompCode,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        generateCompCodeVS: (collectionId) => {
            dispatch(assignCompCodeVS(collectionId));
        },
        getCompCodeVS : (code) => {
            dispatch(getCompCodeVS(code));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VitalSourceAccessCodeSetup);




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/VitalSourceAccessCodeSetupLink.js